// extracted by mini-css-extract-plugin
export var filterIncDec = "_ao-0";
export var leftBorder = "_ao-1";
export var rightBorder = "_ao-2";
export var stringInput = "_ao-3";